import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Input, Select, DatePicker, } from 'antd';
import ModulesFormAction from './Modules.Form.Action';

import moment from 'moment';

const FormItem = Form.Item;
const Option = Select.Option;

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    form?: any;
    formItemLayout?: any;
    formData?: any;
    rules?: any;
    keyName?: any;
    isLine?: boolean;
    lineIndex?: number;
    linesKey: any[];
}

/** 绑定全局数据到props */
@connect((state: ReduxState): IReduxStatePart => ({
    // validateFields(fieldNames: Array<string>, options: Object, callback: ValidateCallback): void;
}))
export default class UIComponents extends UIBasic<IProps, ModulesState, {}> {

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = this.props.formItemLayout;
        const formData = this.props.formData;
        const keyName = this.props.keyName;
        const rules = this.props.rules;
        const linesKey = this.props.linesKey;
        const messageInfos = ModulesAction.modulesState.messageInfos;
        return (
            <FormItem
                {...formItemLayout}
                label={rules.displayText}
            >
                {getFieldDecorator(keyName, {
                    initialValue: this.initValue(rules.inputType),
                    rules: [{
                        required: rules.isRequired,
                        pattern: rules.regex ? ModulesAction.evilFun(rules.regex) : /^/,
                        message: rules.invalidTip,
                        validator: ModulesFormAction.validatorFiledExtra,
                    }],
                })(
                    this.getInputType(rules, keyName, this.props.lineIndex, this.props.isLine)
                )}
                {ModulesFormAction.setMessageInfos(messageInfos.get(this.props.lineIndex === null ? keyName : keyName + '_' + linesKey[this.props.lineIndex]))}
            </FormItem>
        );
    }

    /**
     * 初始化值
     */
    private initValue = (type) => {
        // 判断是行自定义字段 还是单据字段
        let data = this.props.isLine ? this.props.formData.Lines[this.props.lineIndex][this.props.keyName] : this.props.formData[this.props.keyName];

        if (type === 'DATE' || type === 'DATETIME') {
            return ModulesAction.timeStampToFormat(data);
        } else {
            return data;
        }
    }

    /**
     * 获取输入框类型
     */
    private getInputType = (rules, keyName?: string, lineIndex?: number, isLine?: boolean) => {
        let temp = <Input placeholder='' />;
        switch (rules.inputType) {
            case 'TEXT':
                temp = <Input
                    placeholder=''
                    onBlur={e => ModulesFormAction.validateFormValue({
                        fieldName: keyName,
                        fieldType: isLine ? 'LineField' : 'DocField',
                        line: lineIndex !== undefined && lineIndex !== null ? this.props.linesKey[lineIndex] : lineIndex,
                        value: e.target.value,
                    })}
                />;
                break;
            case 'SELECT':
                temp = <Select
                    placeholder=''
                    onChange={e => ModulesFormAction.validateFormValue({
                        fieldName: keyName,
                        fieldType: isLine ? 'LineField' : 'DocField',
                        line: lineIndex,
                        value: e,
                    })}
                >
                    {rules.selectOptions && rules.selectOptions.map((item) => {
                        return <Option value={item.val} key={item.key}>{item.key}</Option>;
                    })}
                </Select>;
                break;
            case 'DATETIME':
                temp = <DatePicker
                    showTime={{ format: 'HH:mm' }}
                    placeholder=''
                    style={{ width: '100%' }}
                    format={'YYYY-MM-DD HH:mm'}
                    onChange={e => ModulesFormAction.validateFormValue({
                        fieldName: keyName,
                        fieldType: isLine ? 'LineField' : 'DocField',
                        line: lineIndex,
                        value: moment(e).valueOf(),
                    })}
                />;
                break;
            case 'DATE':
                temp = <DatePicker
                    showTime={false}
                    placeholder=''
                    style={{ width: '100%' }}
                    format={'YYYY-MM-DD'}
                    onChange={e => ModulesFormAction.validateFormValue({
                        fieldName: keyName,
                        fieldType: isLine ? 'LineField' : 'DocField',
                        line: lineIndex,
                        value: moment(e).valueOf(),
                    })}
                />;
                break;
            default:
                break;
        }
        return temp;
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.TemplateFormItem.tsx